import { Outlet } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import Sidebar from './Sidebar';
import Header from './Header';
import MFAVerifyOverlay from '../MFAVerifyOverlay';

export default function MainLayout() {
  const pendingMFA = useAuthStore((s) => s.pendingMFA);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          {pendingMFA ? <MFAVerifyOverlay /> : <Outlet />}
        </main>
      </div>
    </div>
  );
}
